module.exports = __webpack_public_path__ + "static/media/paw-claws.b4a485b8.svg";